import React from 'react';
import { Helmet } from 'react-helmet';

const Home: React.FC = () => (
  <div className='home-container'>
    <Helmet>
      <title>Andrew Sorensen</title>
      <meta name="description" content="Andrew Sorensen is an IT Professional specializing in Automation Engineering with expertise in testing strategies, problem solving, and team leadership." />
      <meta name="keywords" content="Andrew Sorensen, QA, Quality Assurance, Automation Engineer, IT Professional, Problem Solving, Testing Strategies, Team Leadership, Portfolio" />
    </Helmet>
    <div className="home-content">
      <div className="home-text-container">
        <p className="home-text">
          <h3 className="welcome-text">Welcome</h3>
          <br />
          My name is Andrew Sorensen. I am an IT Professional with a focus in Automation Engineering.  What I enjoy 
          most about IT is solving problems and designing solutions.  With a balance of technical expertise and 
          leadership skills, I thrive in building efficient testing strategies, 
          mentoring team members, and collaborating across departments to deliver reliable, 
          high-performing software.  Thank you for visiting my website.     
        </p>
      </div>
      <div className="home-content-image-container">
          <img src="/pictures/Home.jpg" alt="Andrew Sorensen" className="home-profile-image" />
      </div>
    </div>
  </div>
);

export default Home;